import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

// SOFTCAT 디자인 시스템 사이드바 (sc-sidenav)
const GROUPS = [
    {
        label: "MY 관리",
        items: [
            ["/mypage", "대시보드"],
            ["/mypage/my-info", "개인정보 관리"],
            ["/mypage/notification", "알림 관리"],
        ],
    },
    {
        label: "주문",
        items: [
            ["/mypage/purchase-list", "구매내역"],
            ["/mypage/subscription", "구독관리"],
            ["/mypage/custom-order", "맞춤상품 신청내역"],
        ],
    },
    {
        label: "리뷰 · 문의",
        items: [
            ["/mypage/review-list", "리뷰관리"],
            ["/mypage/review-available-list", "리뷰 가능한 상품"],
            ["/mypage/review-written-list", "내가 작성한 리뷰"],
            ["/mypage/qna", "Q&A관리"],
        ],
    },
    {
        label: "혜택",
        items: [
            ["/mypage/check-coupon", "쿠폰"],
            ["/mypage/check-point", "포인트"],
        ],
    },
];

const MyPageSidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const go = (path) => {
        navigate(path);
        window.scrollTo(0, 0);
    };

    return (
        <nav className="sc-sidenav" aria-label="마이페이지 메뉴">
            {GROUPS.map(({ label, items }) => (
                <React.Fragment key={label}>
                    <div className="sc-sidenav__group">{label}</div>
                    {items.map(([path, text]) => (
                        <button
                            key={path}
                            type="button"
                            className={`sc-sidenav__item${location.pathname === path ? " active" : ""}`}
                            onClick={() => go(path)}
                        >
                            {text}
                        </button>
                    ))}
                </React.Fragment>
            ))}
        </nav>
    );
};

export default MyPageSidebar;
